export default "__VITE_ASSET__DMq52XQa__"